import store from 'dashboard/store';

// A guarda de rota, o onMounted da pagina e o modal pedem os mesmos recursos.
// Sem deduplicacao isso vira tres requisicoes iguais a cada abertura da tela.
const inFlight = new Map();

const fetchOnce = (key, action) => {
  const pending = inFlight.get(key);
  if (pending) return pending;

  const request = store
    .dispatch(action)
    .catch(() => {})
    .finally(() => inFlight.delete(key));

  inFlight.set(key, request);
  return request;
};

const hasRecords = getter => Boolean(store.getters[getter]?.length);

export const hasAgentsPageData = () => hasRecords('agents/getAgents');

// Busca so o que ainda nao esta no store: se a lista ja veio de outra tela
// (a de conversas carrega agentes e equipes), nao repete a chamada.
export const prefetchAgentsPageData = () => {
  const requests = [];

  if (!hasRecords('agents/getAgents')) {
    requests.push(fetchOnce('agents', 'agents/get'));
  }
  if (!hasRecords('customRole/getCustomRoles')) {
    requests.push(fetchOnce('customRoles', 'customRole/getCustomRole'));
  }
  if (!hasRecords('teams/getTeams')) {
    requests.push(fetchOnce('teams', 'teams/get'));
  }

  return Promise.all(requests);
};

// Entrou na pagina com dados em cache: mostra na hora e atualiza por baixo.
export const revalidateAgentsPageData = () => {
  fetchOnce('agents', 'agents/get');
  fetchOnce('customRoles', 'customRole/getCustomRole');
  fetchOnce('teams', 'teams/get');
};
